module.exports = __webpack_public_path__ + "static/img/pic_wuneirong.1f35e5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/home/04search/pic_wuneirong.png
// module id = 433
// module chunks = 2